import { getData, postData, deleteDataMethod } from "helpers/Helper";
import { APP_PATH, COMMON_PATH } from "./apiPath";
import {
  getList,
  addData,
  updateData,
  deleteData,
  getDetail,
  getWithoutPaginationList,
} from "store/actions/common";
//list
export function getList_(value, callback) {
  const {
    page,
    limit,
    url,
    common,
    search_string,
    id,
    match_type,
    sort_by,
    date_val,
    yearly_data,
    filter_gender,
    filter_age,
    post_type,
    category_id,
    role
  } = value || {};

  let urlPath = id
    ? `${common ? COMMON_PATH : APP_PATH}/${url}/${id}`
    : `${common ? COMMON_PATH : APP_PATH}/${url}`;
  if (
    page !== undefined ||
    limit !== undefined ||
    search_string !== undefined ||
    match_type !== undefined ||
    sort_by !== undefined ||
    date_val !== undefined ||
    yearly_data !== undefined ||
    filter_gender !== undefined ||
    filter_age !== undefined ||
    post_type !== undefined ||
    category_id !== undefined||
    role!==undefined
  ) {
    urlPath += `?page=${page}&limit=${limit}`;
    if (category_id !== undefined && category_id !== "") {
      urlPath += `&category_id=${category_id}`;
    }
    if (sort_by !== undefined && sort_by !== "") {
      urlPath += `&sort_by=${sort_by}`;
    }
    if (role !== undefined && role !== "") {
      urlPath += `&role=${role}`;
    }
    if (date_val !== undefined && date_val !== "" && date_val !== false) {
      urlPath += `&date_val=${date_val}`;
    }
    if (search_string !== "" && search_string !== undefined) {
      urlPath += `&search_string=${search_string}`;
    }
    if (match_type !== "" && match_type !== undefined) {
      urlPath += `&match_type=${match_type}`;
    }
    if (yearly_data !== undefined && yearly_data !== "") {
      urlPath += `&yearly_data=${yearly_data}`;
    }
    if (filter_gender !== undefined && filter_gender !== "") {
      urlPath += `&filter_gender=${filter_gender}`;
    }
    if (filter_age !== undefined && filter_age !== "") {
      urlPath += `&filter_age=${filter_age}`;
    }
    if (post_type !== undefined && post_type !== "") {
      urlPath += `&post_type=${post_type}`;
    }
  }

  return (dispatch) =>
    getData(urlPath, value).then((data) => {
      dispatch(getList(data, callback));
      return data;
    });
}

export function getWithoutPaginationList_(value, callback) {
  let urlPath = `${APP_PATH}/${value?.url}`;
  if (value.interval !== undefined && value.interval !== "") {
    urlPath += `?interval=${value.interval}`;
  }
  if (value.module_name !== undefined && value.module_name !== "") {
    urlPath += `${value?.type === "setting" ? "?" : "&"}module=${
      value.module_name
    }`;
  }
  if (value.earning_country !== undefined && value.earning_country !== "") {
    urlPath += `&earning_country=${value.earning_country}`;
  }
  if (value.earning_zipcode !== undefined && value.earning_zipcode !== "") {
    urlPath += `&earning_zipcode=${value.earning_zipcode}`;
  }
  if (
    value.earning_classification !== undefined &&
    value.earning_classification !== ""
  ) {
    urlPath += `&earning_classification=${value.earning_classification}`;
  }
  if (value.earning_wtn !== undefined && value.earning_wtn !== "") {
    urlPath += `&earning_wtn=${value.earning_wtn}`;
  }
  if (value.earning_gender !== undefined && value.earning_gender !== "") {
    urlPath += `&earning_gender=${value.earning_gender}`;
  }
  if (value.earning !== undefined && value.earning !== "") {
    urlPath += `&earning=${value.earning}`;
  }
  if (value.wtn_range !== undefined && value.wtn_range !== "") {
    urlPath += `&wtn_range=${value.wtn_range}`;
  }
  if (value.type !== undefined && value.type !== "") {
    urlPath += `&type=${value.type}`;
  }
  return (dispatch) =>
    getData(urlPath, value).then((data) => {
      dispatch(getWithoutPaginationList(data, callback));
      return data;
    });
}
//add
export function addData_(value, callback) {
  return (dispatch) =>
    postData(`${APP_PATH}/${value?.url}`, value).then((data) => {
      dispatch(addData(data, callback));
      return data;
    });
}

export function updateData_(value, callback) {
  return (dispatch) =>
    postData(`${APP_PATH}/${value?.url}`, value).then((data) => {
      dispatch(updateData(data, callback));
      return data;
    });
}

export function deleteData_(value, callback) {
  let url = `${APP_PATH}/${value?.url}/${value?.id}`;
  return (dispatch) =>
    deleteDataMethod(url).then((data) => {
      dispatch(deleteData(data, callback));
      return data;
    });
}
export function getDetail_(value, callback) {
  let url = `${APP_PATH}/${value?.url}/${value?.id}`;
  return (dispatch) =>
    getData(url).then((data) => {
      dispatch(getDetail(data, callback));
      return data;
    });
}
